import { useContext } from 'react';
import { DataContext } from '../contexts/Data.context';
export const useAlgoliaDataContext = () => useContext(DataContext);
